'use client';
import * as HoverCard from '@radix-ui/react-hover-card';
import styles from './index.module.css';

const PreviewHoverCard: React.FC<{ trigger: React.ReactNode; children?: React.ReactNode }> = ({
  trigger = <div>Hover</div>,
  children,
}) => {
  return (
    <HoverCard.Root>
      <HoverCard.Trigger asChild>{trigger}</HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content className={styles.HoverCardContent} sideOffset={5}>
          {children}
          <HoverCard.Arrow className={styles.HoverCardArrow} />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};

export default PreviewHoverCard;
